module.exports = __webpack_public_path__ + "static/media/lambda_curriculum.f5b234ea.mp4";